import * as React from 'react';
import type { SVGProps } from 'react';
const SvgStreamlineClipboard = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 16 16"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M8 6.688v5.25M10.625 9.313h-5.25M10.861 2.225h1.864c.58 0 1.05.47 1.05 1.05v10.5c0 .58-.47 1.05-1.05 1.05h-9.45c-.58 0-1.05-.47-1.05-1.05v-10.5c0-.58.47-1.05 1.05-1.05H5.14"
    />
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.3}
      d="M9.575 3.8h-3.15a1.312 1.312 0 1 1 0-2.625h3.15a1.312 1.312 0 0 1 0 2.625"
    />
  </svg>
);
export default SvgStreamlineClipboard;
